import { setLoginSuccessWithStorageThunk as setCoreLoginSuccessWithStorageThunk } from '@liefersoft/pos-ui-core'
import { setLoginData, setLoginFailed, setLogout } from '../../../../action'
import { removeLocalStorageAccessToken, removeLocalStorageAuthUuid, removeLocalStorageGlobalModalData, removeLocalStorageRefreshToken } from '../../../../../helper/clientMonitor'
import { localStorageApi } from '../../../../../helper/localStorageApi'
import { removeCookieTokens } from '../../../../../helper/cookieToken'
import { closeClientMonitorWindow } from '../../../../../component/ClientMonitorWindow/helper'
import { isNativeAppMode } from '../../../../../helper/clientMonitor'

export const setLoginDataWithStorageThunk = ({ email, companyIndex }) => dispatch => {
	dispatch(setLoginData({ email, companyIndex }))
	if (email) {
		localStorageApi.setItem('login', email)
	}
	if (companyIndex) {
		localStorageApi.setItem('companyIndex', companyIndex)
	} else {
		localStorageApi.removeItem('companyIndex')
	}
}

export const setLoginSuccessWithStorageThunk = ({ accessToken, refreshToken }) => dispatch => {
	const coreLoginSuccessAction = setCoreLoginSuccessWithStorageThunk({ accessToken, refreshToken })

	if (typeof coreLoginSuccessAction === 'function') {
		return coreLoginSuccessAction(dispatch)
	}

	return dispatch(coreLoginSuccessAction)
}

export const setLoginFailedWithStorageThunk = () => dispatch => {
	dispatch(setLoginFailed())
	removeLocalStorageAccessToken()
	removeLocalStorageRefreshToken()
	removeLocalStorageAuthUuid()
	removeCookieTokens()
}

export const setLogoutWithStorageThunk = () => dispatch => {
	if (isNativeAppMode()) {
		closeClientMonitorWindow()
	}
	dispatch(setLogout())
	removeLocalStorageAccessToken()
	removeLocalStorageRefreshToken()
	removeLocalStorageAuthUuid()
	removeLocalStorageGlobalModalData()
	removeCookieTokens()
}
